var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeHide({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2286 4.18571C13.4238 3.99044 13.4238 3.67386 13.2286 3.4786C13.0333 3.28334 12.7167 3.28334 12.5214 3.4786L11.247 4.75306C10.2937 4.19497 9.18438 3.87505 8 3.87505C5.27273 3.87505 2.94364 5.57141 2 7.96596C2.54001 9.33627 3.53374 10.4779 4.79616 11.2039L3.47855 12.5215C3.28329 12.7168 3.28329 13.0333 3.47855 13.2286C3.67382 13.4239 3.9904 13.4239 4.18566 13.2286L13.2286 4.18571ZM6.08894 9.91111L6.85944 9.1406C6.55345 8.84347 6.36364 8.42738 6.36364 7.96596C6.36364 7.0605 7.09455 6.32959 8 6.32959C8.46142 6.32959 8.87751 6.5194 9.17465 6.8254L9.94515 6.05489C9.45023 5.55121 8.76139 5.23868 8 5.23868C6.49455 5.23868 5.27273 6.4605 5.27273 7.96596C5.27273 8.72735 5.58525 9.41619 6.08894 9.91111ZM10.7238 8.10467L12.8028 6.02571C13.3088 6.59159 13.7168 7.24733 14 7.96596C13.0564 10.3605 10.7273 12.0569 8 12.0569C7.61459 12.0569 7.23714 12.023 6.87042 11.9581L8.13872 10.6898C9.53385 10.6198 10.6538 9.4998 10.7238 8.10467Z",
    fill: "#002466"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeHide);
export default __webpack_public_path__ + "static/media/eye-hide.4dda7134f4bd221da24f1f39bb56df72.svg";
export { ForwardRef as ReactComponent };